import React, { useState, useEffect } from 'react';
import HizmetCard from '../components/HizmetCard';
import { getHizmetler } from '../services/api';
import './Hizmetler.css';

const Hizmetler = () => {
  const [hizmetler, setHizmetler] = useState([]);

  useEffect(() => {
    getHizmetler()
      .then(res => setHizmetler(res.data.results || res.data))
      .catch(err => console.error(err));
  }, []);

  return (
    <div className="hizmetler-page">
      <section className="page-hero">
        <div className="page-hero-overlay"></div>
        <div className="page-hero-content">
          <h1>Hizmetlerimiz</h1>
          <p>Aracınız için profesyonel bakım ve onarım hizmetleri</p>
        </div>
      </section>

      <section className="hizmetler-content">
        <div className="container">
          <div className="hizmetler-grid">
            {hizmetler.map(hizmet => (
              <HizmetCard key={hizmet.id} hizmet={hizmet} />
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default Hizmetler;
